import React, { useState, useEffect, useRef } from "react";
import "../assets/css/Campaigns.css";
import "../assets/css/Vox.css";
import Sidebar from "../components/sidebar";
import ScriptDetail from "../components/scriptDetail";
import config from "../config";
import "../assets/css/Stat.css";
import "../assets/css/Phone-section.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import { useUser } from "../context/UserContext";

function ContactCall({ contentMinimized, data, onClose }) {
  const [loading, setLoading] = useState(false);
  const [campaignData, setCampaignData] = useState(null);
  const [callStatus, setCallStatus] = useState("");
  const [updateContactformErrors, setupdateContactformErrors] = useState({});
  const [notes, setNotes] = useState([]);
  const navigate = useNavigate();
  const isMountedRef = useRef(true);
  const timeoutRef = useRef(null);
  const [updateContactData, setUpdateContactData] = useState({
    name: data?.contact?.name || "",
    last_name: data?.contact?.last_name || "",
    contact_primary: data?.contact?.contact_primary,
    company: data?.contact?.company,
    street: data?.contact?.street || "",
    city: data?.contact?.city || "",
    state: data?.contact?.state || "",
    country: data?.contact?.country || "",
    title: "",
    contact_id: data?.contact?.id,
    registration_number: data?.contact?.registration_number,
    name: data?.contact?.name,
    // id: data?.contact?.id,
    vertical_type: data?.contact?.vertical_type,
    order_id: data?.contact?.order_id,
    caller_type: data?.contact?.caller_type,
    interaction_type: data?.contact?.interaction_type,
    interaction_category: data?.contact?.interaction_category,
    interaction_sub_category: data?.contact?.interaction_sub_category,
    note: data?.contact?.note,
    ticket_required: data?.contact?.ticket_required,
  });
  const { user } = useUser();

  const OPTIONS_VERTICAL_TYPE = [
    { label: "Parcel", value: 1 },
    { label: "Ride", value: 2 },
    { label: "Food", value: 3 },
    { label: "Rental", value: 4 },
    { label: "Realtime Parcel", value: 5 },
  ]

  const CALLER_TYPE_OPTIONS = {
    1: [
      { label: "Merchant", value: 1 },
      { label: "User", value: 2 },
      { label: "Delivery Agent", value: 3 },
      { label: "Pickup Agent", value: 4 }
    ],
    2: [
      { label: "Rider", value: 5 },
      { label: "Captain", value: 6 },
      { label: "Tuk Tuk Chalak", value: 7 },
      { label: "User", value: 2 }
    ],
    3: [
      { label: "Pathao Hero", value: 8 },
      { label: "Restaurant", value: 9 },
      { label: "User", value: 2 }
    ],
    4: [
      { label: "Captain", value: 6 },
      { label: "User", value: 2 },
      { label: "Rental Company", value: 10 }
    ],
    5: [
      { label: "Realtime Parcel", value: 11 },
      { label: "Rider", value: 5 },
      { label: "S. User", value: 13 },
      { label: "R. User", value: 14 }
    ]
  };

  const INTERACTION_TYPE_OPTIONS = {
    1: [
      { label: "Query", value: 1 },
      { label: "Complain", value: 2 },
      { label: "Request", value: 3 }
    ],
    2: [
      { label: "Query", value: 1 },
      { label: "Complain", value: 2 },
      { label: "Grievance", value: 4 }
    ],
    3: [
      { label: "Query", value: 1 },
      { label: "Complain", value: 2 },
      { label: "Grievance", value: 4 }
    ],
    4: [
      { label: "Query", value: 1 },
      { label: "Complain", value: 2 },
      { label: "Grievance", value: 4 }
    ]
  };

  const INTERACTION_CATEGORY = [
    { label: "Execution Request", value: 1 },
    { label: "Forcefully Taken", value: 2 },
    { label: "Inquiry", value: 3 },
    { label: "Unprofessionalism", value: 4 },
    { label: "Charge Extra/Wrong COD", value: 5 },
    { label: "Damage", value: 6 },
    { label: "Lost", value: 7 },
    { label: "No Entry/Cancelled", value: 8 },
    { label: "Wrong Routing", value: 9 },
    { label: "Wrong tag/Parcel swapped", value: 10 },
    { label: "Breach of CLOSEBOX", value: 11 },
    { label: "Panel Status", value: 12 },
    { label: "Complain Why Return", value: 13 },
    { label: "Coverage/Point Delivery", value: 14 },
    { label: "Delivery Delay", value: 15 },
    { label: "Payment Issue", value: 16 },
    { label: "Pickup", value: 17 },
    { label: "Return Delay", value: 18 },
    { label: "Return Exchange", value: 19 },
    { label: "Reverse Pickup", value: 20 },
  ]

  const INTERACTION_SUB_CATEGORIES = {
    1: [
      { label: "Order Cancellation Request", value: 1 },
      { label: "Price Updatation Request", value: 2 },
      { label: "Customer Address Update", value: 3 },
      { label: "Customer Contact Update", value: 4 },
      { label: "Payment Info Update", value: 5 },
      { label: "Profile Info Update", value: 6 },
      { label: "Profile Password Update", value: 7 },
      { label: "Store Approval", value: 8 },
      { label: "Store Info Update", value: 9 },
      { label: "Hold Request", value: 10 },
      { label: "Partial delivery request - special instruction", value: 11 },
      { label: "Uninformed Info change", value: 12 },
      { label: "Agent details missing/wrong number", value: 13 },
      { label: "Urgent Delivery", value: 14 },
    ],
    2: [
      { label: "Defective Product Sent By Merchant", value: 15 },
      { label: "Fraudulent Activity", value: 16 },
    ],
    3: [
      { label: "C2C", value: 17 },
      { label: "Delivery/Return", value: 18 },
      { label: "Delivery Hold", value: 19 },
      { label: "Order Info/Status", value: 20 },
      { label: "Coverage Area", value: 21 },
      { label: "Feedback/Suggestion", value: 22 },
      { label: "Courier Service", value: 23 },
      { label: "Silent Call/Chat", value: 24 },
      { label: "Merchant Panel/App", value: 25 },
      { label: "Interested To Join As Agent", value: 26 },
      { label: "Interested To Join As Merchant", value: 27 },
      { label: "Other Vertical Transfer", value: 28 },
      { label: "Payment Process Courier", value: 29 },
      { label: "Pathao Outbound Call", value: 30 },
      { label: "Pickup Entry", value: 31 },
      { label: "Reverse Pickup", value: 32 },
      { label: "Return Exchange", value: 33 },
    ],
    4: [
      { label: "Misbehavior By PA", value: 34 },
      { label: "Misbehavior By DA", value: 35 },
      { label: "Misbehavior By Employee", value: 36 },
    ],
    5: [
      { label: "Extra Charge Offered", value: 37 },
      { label: "Extra Charge Demanded", value: 38 },
      { label: "Wrong COD Collection", value: 39 },
      { label: "Wrong Weight Input", value: 40 },
      { label: "Miscalculation Of Weight Charge", value: 41 },
      { label: "Miscalculation Of Delivery/Return Charge", value: 42 },
      { label: "Miscalculation Of COD Charge", value: 43 },
    ],
    6: [
      { label: "Poor Packaging", value: 44 },
      { label: "Not Processed Under Fragile Category", value: 45 },
      { label: "Act Of God", value: 46 },
      { label: "Defective Product Sent By Merchant", value: 47 },
      { label: "Liquid Leakage", value: 48 },
      { label: "Stapler Pin", value: 49 },
      { label: "Rat Bites", value: 50 },
      { label: "Mishandling", value: 51 },
    ],
    7: [
      { label: "Trackless", value: 52 },
      { label: "Parcel Lost By OPS", value: 53 },
      { label: "Hijacking/Robbery", value: 54 },
      { label: "Poor Packaging", value: 55 },
      { label: "Empty Package/Empty Packet/Empty Box", value: 56 },
      { label: "Partial Missing", value: 57 },
    ],
    8: [
      { label: "Double Entry", value: 58 },
      { label: "No Entry", value: 59 },
      { label: "Info Mismatch", value: 60 },
      { label: "Product Not Given By Merchant", value: 61 },
    ],
    9: [
      { label: "Incomplete/ Wrong Info Input On Panel", value: 62 },
      { label: "Wrong Routing By Processing Team", value: 63 },
      { label: "Wrong POD Attached", value: 64 },
      { label: "Technical Error", value: 65 },
    ],
    10: [
      { label: "Wrong Tag By LMH", value: 66 },
      { label: "Wrong Tag By FMH", value: 67 },
      { label: "Wrong Tag By Processing Team", value: 68 },
      { label: "Wrong Invoice Attached By Merchant", value: 69 },
    ],
    11: [
      { label: "Forcefully Checked By Customer", value: 70 },
      { label: "POD Not Followed By Agent", value: 71 },
    ],
    12: [
      { label: "Agent/Hub Didn't Update Status Timely", value: 72 },
      { label: "Wrong Status", value: 73 },
      { label: "Technical Error", value: 74 },
    ],
    13: [
      { label: "Improper Delivery Attempt", value: 75 },
      { label: "Merchant Not Informed Before Returning", value: 76 },
      { label: "Reprocess Request by Merchant", value: 77 },
      { label: "False Return Note", value: 78 },
    ],
    14: [
      { label: "Remote Area", value: 79 },
      { label: "Agent Denies Home Delivery", value: 80 },
    ],
    15: [
      { label: "Rescheduled By Customer/Customer Unreachable", value: 81 },
      { label: "Remote Area", value: 82 },
      { label: "Delivery Not Attempted By Agent", value: 83 },
      { label: "False Hold Note", value: 84 },
      { label: "Processing Delay", value: 85 },
      { label: "Rider Shortage", value: 86 },
      { label: "Delivery Delay - On-Demand", value: 87 },
      { label: "Delivery Time Query", value: 88 },
    ],
    16: [
      { label: "Hub Payment Not Submitted", value: 89 },
      { label: "Cash Lost By OPS", value: 90 },
      { label: "Invoice Not Generated", value: 91 },
      { label: "Invoice Generated But Payment Not Disbursed", value: 92 },
    ],
    17: [
      { label: "Pickup Request", value: 93 },
      { label: "Rider Shortage", value: 94 },
      { label: "Pickup Timing Issue", value: 95 },
      { label: "Pickup Request - On-Demand", value: 96 },
      { label: "Pickup Not Attempted By Agent", value: 97 },
    ],
    18: [
      { label: "Processing Delay", value: 98 },
      { label: "Merchant Unreachable/Store Closed", value: 99 },
      { label: "Return ID Not Created", value: 100 },
      { label: "Return Time Query", value: 101 },
    ],
    19: [
      { label: "POD Not Followed By Agent", value: 102 },
      { label: "Exchange Not Provided By Customer", value: 103 },
      { label: "Return ID Not Created", value: 104 },
    ],
    20: [
      { label: "Pickup Agent Not Assigned", value: 105 },
      { label: "Pickup Timing Issue", value: 106 },
    ],
  };

  const ticket_required = [
    { label: "No", value: 0 },
    { label: "Yes", value: 1 },
  ]

  const fetchNotes = async (contactId) => {
    setNotes([]);
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/reports/${contactId}/notes?limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();

      if (result.success) {
        setNotes(result.data);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    }
  };

  useEffect(() => {
    fetchNotes(data?.contact?.id);
  }, []);


  function getPlainText(remarks) {
    try {
      const parsedRemarks = JSON.parse(remarks);

      if (parsedRemarks.blocks && Array.isArray(parsedRemarks.blocks)) {
        return parsedRemarks.blocks.map((block) => block.text).join(" ");
      }
    } catch (e) {}

    return remarks;
  }

  const changeContactValue = (e) => {
    const { name, value } = e.target;
    setUpdateContactData({ ...updateContactData, [name]: value });
    setupdateContactformErrors({ ...updateContactformErrors, [name]: "" });
  };

  const validateUpdateContactFields = () => {
    const errors = {};
    // if (!updateContactData?.first_name) {
    //   errors.first_name = "First name is required";
    // }
    // if (!updateContactData?.last_name) {
    //   errors.last_name = "Last name is required";
    // }
    if (!updateContactData?.contact_primary) {
      errors.contact_primary = "Contact number is required";
    }
    // if (!updateContactData?.remarks) {
    //   errors.remarks = "Remarks is required";
    // }
    // if (!updateContactData?.remarksTitle) {
    //   errors.remarksTitle = "Remarks title is required";
    // }
    // if (!updateContactData?.company) {
    //   errors.company = "Company is required";
    // }
    // if (!updateContactData?.state) {
    //   errors.state = "State is required";
    // }
    // if (!updateContactData?.street) {
    //   errors.street = "Street is required";
    // }
    // if (!updateContactData?.city) {
    //   errors.city = "City is required";
    // }
    // if (!updateContactData?.country) {
    //   errors.country = "Country is required";
    // }
    setupdateContactformErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUpdateContact = async (e, status = false) => {
    if (loading) {
      return;
    }

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!validateUpdateContactFields()) {
      return;
    }

    const contactNumberList = [
      {
        value: updateContactData.contact_primary,
        type: "1",
      },
    ];

    const dataToSend = {
      contact_number: contactNumberList,
      registration_number: updateContactData.registration_number,
      name: updateContactData.name,
      id: updateContactData.id,
      vertical_type: updateContactData.vertical_type,
      order_id: updateContactData.order_id,
      caller_type: updateContactData.caller_type,
      interaction_type: updateContactData.interaction_type,
      interaction_category: updateContactData.interaction_category,
      interaction_sub_category: updateContactData.interaction_sub_category,
      note: updateContactData.note,
      ticket_required: updateContactData.ticket_required,
      created_by: user.id
    };

    // Filter out any keys with value undefined, null, or empty string
    const cleanedData = Object.entries(dataToSend).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const token = localStorage.getItem("token");

    setLoading(true);

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/contacts/${updateContactData.contact_primary}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(cleanedData),
        }
      );

      const data = await response.json();
      
      if (data.success) {
        toast.success(data.message || "Contact updated successfully");
        // setUpdateContactData({});
        setupdateContactformErrors({});
        fetchNotes(updateContactData.contact_id);
      } else {
        toast.error(data.message || "Failed to updated contact");
      }
    } catch (error) {
      console.error("Error updating contact:", error);
      toast.error("Error updating contact");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const fetchCallStatus = async (campaign_id, call_id) => {
    try {
      //   if (loading) {
      //     return;
      //   }
      if (!isMountedRef.current) return;
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/campaigns/${campaign_id}/calls/${call_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        if (Object.keys(data.data).length === 0) {
          timeoutRef.current = setTimeout(() => {
            if (isMountedRef.current) fetchCallStatus(campaign_id, call_id);
          }, 15000);
        } else {
          setCallStatus(data.data.call_event);
          if (
            data.data.call_event !== "LEAD_CALL_HANGUP" &&
            data.data.call_event !== "AGENT_CALL_HANGUP"
          ) {
            fetchCallStatus(campaign_id, call_id);
          }
        }
      } else {
        toast.error(data.message || "Failed to retrieve call status");
      }
    } catch (error) {
      console.error("Error fetching call status:", error);
      toast.error("Error fetching call status");
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <FadeLoader
            color="#808080"
            height={10}
            width={3}
            radius={0}
            margin={-5}
          />
        </div>
      )}
      <div
        className="modal-overlay"
        style={{
          zIndex: 999999,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          overflowY: "auto",
        }}
      >
        <div className="modal-xl modal-dialog modal-dialog-centered custom-modal-width">
          <div className="modal-content" style={{ backgroundColor: "#fcfcfc" }}>
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
              }}
            >
              <h5 className="modal-title" style={{ margin: 0 }}>
                Contact Details
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  lineHeight: "1",
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="lyt_box mt-4">
                <div className="row g-4">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="block-widget">
                      <h6>Form</h6>
                      <form onSubmit={(e) => handleUpdateContact(e, false)}>
                        <div className="form_group">
                          <label className="form-label"> Contact Number*</label>
                          <input
                            type="number"
                            className="form-control"
                            name="contact_primary"
                            value={updateContactData.contact_primary || ""}
                            onChange={changeContactValue}
                          />
                          {updateContactformErrors.contact_primary && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.contact_primary}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Registration Number</label>
                          <input
                            type="number"
                            className="form-control"
                            name="registration_number"
                            value={updateContactData.registration_number || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={updateContactData.name || ""}
                            onChange={changeContactValue}
                          />
                          {updateContactformErrors.name && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.name}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">ID</label>
                          <input
                            type="number"
                            className="form-control"
                            name="id"
                            value={updateContactData.id || ""}
                            onChange={changeContactValue}
                          />
                          {updateContactformErrors.id && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.id}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Vertical Type</label>
                          <select id="source-type" name="vertical_type" value={updateContactData.vertical_type || ""}
                            onChange={(e) => {
                              changeContactValue(e);
                              setUpdateContactData((prev) => ({
                                ...prev,
                                caller_type: "",
                                interaction_type: ""
                              }));
                            }}>
                            <option value="" disabled selected>Select Vertical Type</option>
                            {OPTIONS_VERTICAL_TYPE.map((item) => (
                              <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form_group">
                          <label className="form-label">Consignment/Ride/Order ID</label>
                          <input
                            type="number"
                            className="form-control"
                            name="order_id"
                            value={updateContactData.order_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Caller Type</label>
                          <select id="caller-type"
                            name="caller_type"
                            value={updateContactData.caller_type || ""}
                            onChange={changeContactValue}>
                            <option value="" disabled selected>Select Caller Type</option>
                            {(CALLER_TYPE_OPTIONS[updateContactData.vertical_type] || []).map((type, index) => (
                              <option key={index} value={type.value}>{type.label}</option>
                            ))}

                          </select>
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Type</label>
                          <select id="source-type"
                            name="interaction_type"
                            value={updateContactData.interaction_type || ""}
                            onChange={changeContactValue}>
                            <option value="" disabled selected>Select Interaction Type</option>
                            {(INTERACTION_TYPE_OPTIONS[updateContactData.vertical_type] || []).map((type, index) => (
                              <option key={index} value={type.value}>{type.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Category</label>
                          <select id="source-type" name="interaction_category"
                            value={updateContactData.interaction_category}
                            onChange={(e) => {
                              changeContactValue(e);
                              setUpdateContactData((prev) => ({
                                ...prev,
                                interaction_sub_category: "",
                              }));
                            }}>
                            <option value="" disabled selected>Select Interaction Category</option>
                            {INTERACTION_CATEGORY.map((item) => (
                              <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Sub Category</label>
                          <select id="source-type" name="interaction_sub_category"
                            value={updateContactData.interaction_sub_category}
                            onChange={changeContactValue}>
                            <option value="" disabled selected>Select Interaction Sub Category</option>
                            {(INTERACTION_SUB_CATEGORIES[updateContactData.interaction_category] || []).map((type, index) => (
                              <option key={index} value={type.value}>{type.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form_group">
                          <label className="form-label">Note</label>
                          <textarea
                            className="form-control"
                            name="note"
                            value={updateContactData.note || ""}
                            onChange={changeContactValue}
                            rows={4}
                            style={{ height: "100px" }}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Ticket required</label>
                          <select id="source-type" name="ticket_required" value={updateContactData.ticket_required} onChange={changeContactValue}>
                            <option value="" disabled selected>Select Ticket required</option>
                            {ticket_required.map((item, index) => (
                              <option key={index} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={loading}
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="block-widget">
                      <ScriptDetail
                        scriptData={{
                          script_name: campaignData?.scripts?.script_name,
                          short_desc: campaignData?.scripts?.short_desc,
                          script_text: campaignData?.scripts?.script_texts,
                        }}
                      ></ScriptDetail>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="block-widget">
                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          width: "100%",
                        }}
                      >
                        <table
                          className="table table-striped"
                          style={{ width: "100%", tableLayout: "fixed" }}
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "33%" }}>Agent name</th>
                              <th style={{ width: "33%" }}>Remark</th>
                              <th style={{ width: "33%" }}>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(notes) && notes.length > 0 ? (
                              notes.map((note, index) => (
                                <tr key={note.id}>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {note["UserDetail.Agents.agent_name"] || ""}
                                  </td>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {getPlainText(note.note)}
                                  </td>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {note.created_at}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <h2>Phone</h2>
                      <div className="phone-block mt-3">
                        <div id="output">
                          <div id="incoming-number"></div>
                          <input type="text" id="numberToCall" />
                        </div>
                        <div className="number-flex">
                          <div className="digit box" id="one">
                            <button className="keypad not-visible">1</button>
                          </div>
                          <div className="digit box" id="two">
                            <button className="keypad not-visible">2</button>
                            <div className="sub">ABC</div>
                          </div>
                          <div className="digit box" id="three">
                            <button className="keypad not-visible">3</button>
                            <div className="sub">DEF</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box" id="four">
                            <button className="keypad not-visible">4</button>
                            <div className="sub">GHI</div>
                          </div>
                          <div className="digit box" id="five">
                            <button className="keypad not-visible">5</button>
                            <div className="sub">JKL</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">6</button>
                            <div className="sub">MNO</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box">
                            <button className="keypad not-visible">7</button>
                            <div className="sub">PQRS</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">8</button>
                            <div className="sub">TUV</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">9</button>
                            <div className="sub">WXYZ</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box">
                            <button className="keypad not-visible">*</button>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">0</button>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">#</button>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box hold">
                            <input
                              type="checkbox"
                              className="not-visible"
                              id="hold"
                            />
                            <i className="icon-pause"></i>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">+</button>
                          </div>
                          <div className="digit box mute">
                            <input
                              type="checkbox"
                              className="not-visible"
                              id="mute"
                            />
                            <i className="icon-mic"></i>
                          </div>
                        </div>
                        <div className="botrow">
                          <div className="call reject" id="hangup" disabled>
                            <button className="not-visible">
                              <i className="icon-phone" aria-hidden="true"></i>
                            </button>
                          </div>
                          <div className="call answer" id="call">
                            <button className="not-visible">
                              <i className="icon-phone" aria-hidden="true"></i>
                            </button>
                          </div>

                          <i
                            className="icon-arrow-left backspace"
                            aria-hidden="true"
                          >
                            {" "}
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex justify-content-end my-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleUpdateContact(null, true)}
                    disabled={loading}
                  >
                    Submit and Call next
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactCall;
